export default __webpack_public_path__ + "static/media/filter.25993575.svg";